<template>
    <svg aria-hidden="true" focusable="false" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="15" cy="15" r="14.5" fill="white" stroke="#9D9FA2" />
        <ellipse cx="8.8637" cy="10.2273" rx="0.681818" ry="0.681818" fill="black" />
        <path d="M11.5911 10.2273H21.1365" stroke="black" stroke-linecap="round" />
        <ellipse cx="8.8637" cy="15" rx="0.681818" ry="0.681818" fill="black" />
        <path d="M11.5911 15H21.1365" stroke="black" stroke-linecap="round" />
        <ellipse cx="8.8637" cy="19.7727" rx="0.681818" ry="0.681818" fill="black" />
        <path d="M11.5911 19.7727H21.1365" stroke="black" stroke-linecap="round" />
    </svg>
</template>
